module.exports = __webpack_public_path__ + "static/background-large-5d6c64efbdf5ea14541351c3019c1c1f.svg";